<script setup lang="ts">
import {SearchBarAutoCompleteItem} from "@/auto-complete-searchbar/interfaces/ISearchBarAutoComplete";
import {ref, watch} from "vue";
import {productApi} from "@/container";
import SearchBarAutoCompleteService from "@/auto-complete-searchbar/services/SearchBarAutoCompleteService";
import LaboratoryProduct from "@/core/interfaces/laboratory/LaboratoryProduct";
import debounce from "lodash.debounce";

const props = defineProps<{
    items: SearchBarAutoCompleteItem[]
}>();
const emits = defineEmits<{
    (e: "productLoaded", products: LaboratoryProduct[]): void;
}>();
const products = ref<LaboratoryProduct[]>([]);
const loading = ref(false);
const selected = defineModel<number[]>("selected", {
    default: () => []
});

const loadProducts = debounce((search: SearchBarAutoCompleteItem[]) => {
    loading.value = true;
    productApi().index<false>({
        ...SearchBarAutoCompleteService.transformToQueryParams(search),
        dispensationIds: [4], // Auto inject dispensation ID to match elasticsearch index.
        raw: false
    })
        .then((response) => {
            emits("productLoaded", response);
            products.value = response;
        })
        .catch(() => {
            products.value = [];
        })
        .finally(() => {
            loading.value = false;
        });
}, 1000);

watch(() => props.items, (items) => {
    if (items.length > 0) {
        loadProducts(items);
    } else {
        products.value = [];
    }
}, {immediate: true});

const headers = [
    {
        key: "name",
        title: "Nom"
    },
];
</script>

<template>
  <v-data-table
    v-model="selected"
    select-strategy="all"
    show-select
    fixed-header
    :headers="headers"
    :items="products"
    :loading="loading"
    class="max-h-[60dvh]"
    item-value="id"
  />
</template>

<style scoped>

</style>
